

// Generated class ChangelogCommitted_ManagedObject

class ChangelogCommitted_ManagedObject extends MIOManagedObject
{

    // Property: appIDs
    set appIDs(value:any) {
        this.setValueForKey(value, 'appIDs');
    }
    get appIDs():any {
        return this.valueForKey('appIDs');
    }
    set appIDsPrimitiveValue(value:any) {
        this.setPrimitiveValueForKey(value, 'appIDs');
    }
    get appIDsPrimitiveValue():any {
        return this.primitiveValueForKey('appIDs');
    }

    // Property: changelogSyncID
    set changelogSyncID(value:number) {
        this.setValueForKey(value, 'changelogSyncID');
    }
    get changelogSyncID():number {
        return this.valueForKey('changelogSyncID');
    }
    set changelogSyncIDPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'changelogSyncID');
    }
    get changelogSyncIDPrimitiveValue():number {
        return this.primitiveValueForKey('changelogSyncID');
    }

    // Property: createdAt
    set createdAt(value:Date) {
        this.setValueForKey(value, 'createdAt');
    }
    get createdAt():Date {
        return this.valueForKey('createdAt');
    }
    set createdAtPrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'createdAt');
    }
    get createdAtPrimitiveValue():Date {
        return this.primitiveValueForKey('createdAt');
    }

    // Property: entities
    set entities(value:any) {
        this.setValueForKey(value, 'entities');
    }
    get entities():any {
        return this.valueForKey('entities');
    }
    set entitiesPrimitiveValue(value:any) {
        this.setPrimitiveValueForKey(value, 'entities');
    }
    get entitiesPrimitiveValue():any {
        return this.primitiveValueForKey('entities');
    }

    // Property: error
    set error(value:string) {
        this.setValueForKey(value, 'error');
    }
    get error():string {
        return this.valueForKey('error');
    }
    set errorPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'error');
    }
    get errorPrimitiveValue():string {
        return this.primitiveValueForKey('error');
    }

    // Property: identifier
    set identifier(value:string) {
        this.setValueForKey(value, 'identifier');
    }
    get identifier():string {
        return this.valueForKey('identifier');
    }
    set identifierPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'identifier');
    }
    get identifierPrimitiveValue():string {
        return this.primitiveValueForKey('identifier');
    }

    // Property: status
    set status(value:number) {
        this.setValueForKey(value, 'status');
    }
    get status():number {
        return this.valueForKey('status');
    }
    set statusPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'status');
    }
    get statusPrimitiveValue():number {
        return this.primitiveValueForKey('status');
    }

    // Property: syncByAppID
    set syncByAppID(value:string) {
        this.setValueForKey(value, 'syncByAppID');
    }
    get syncByAppID():string {
        return this.valueForKey('syncByAppID');
    }
    set syncByAppIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'syncByAppID');
    }
    get syncByAppIDPrimitiveValue():string {
        return this.primitiveValueForKey('syncByAppID');
    }

    // Property: syncIndex
    set syncIndex(value:number) {
        this.setValueForKey(value, 'syncIndex');
    }
    get syncIndex():number {
        return this.valueForKey('syncIndex');
    }
    set syncIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'syncIndex');
    }
    get syncIndexPrimitiveValue():number {
        return this.primitiveValueForKey('syncIndex');
    }

    // Property: updatedByAppID
    set updatedByAppID(value:string) {
        this.setValueForKey(value, 'updatedByAppID');
    }
    get updatedByAppID():string {
        return this.valueForKey('updatedByAppID');
    }
    set updatedByAppIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'updatedByAppID');
    }
    get updatedByAppIDPrimitiveValue():string {
        return this.primitiveValueForKey('updatedByAppID');
    }
}
